import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  IpBgpSubscriptionDetailsGQL,
  IpBgpSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { IpBgpSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { IpSubscriptionViewComponent } from "./ip-subscription-view";

@Component({
  selector: "ip-bgp-subscription",
  templateUrl: "ip-bgp-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IpSubscriptionViewComponent, SubscriptionPageComponent],
})
export class IpBgpSubscriptionComponent extends GenericSubscription<
  IpBgpSubscriptionDetailsQuery,
  IpBgpSubscriptionDetails
> {
  protected query = inject(IpBgpSubscriptionDetailsGQL);

  protected onQuerySuccess(data: IpBgpSubscriptionDetailsQuery): IpBgpSubscriptionDetails {
    return data.ipBgpDetails;
  }
}
